export const HowItWorksLandingContent = [
    {
        step: 1,
        icon: 'pencil',
        header: 'Submit your request',
        text: '',
    },
    {
        step: 2,
        icon: 'tick',
        header: "We'll find your top 5 advisers",
        text:
            "We'll search our directory to shortlist the top 5 Financial Advisers for your situation. " +
            "Then we'll send your enquiry to the best!",
    },
    {
        step: 3,
        icon: 'phone-outgoing',
        header: 'Speak to an adviser',
        text: 'Have a free, no obligation chat with the adviser we send your enquiry to',
    },
];

export const HowItWorksContactContent = [
    {
        icon: 'pencil',
        header: 'Submit your request',
        text: "Simply fill in your details below and tell us how many quotes you'd like ",
    },
    {
        icon: 'tick',
        header: "We'll find your best matches",
        text: "We'll search our directory to find the top advisers for you",
    },
    {
        icon: 'phone-outgoing',
        header: 'Speak to an adviser',
        text: 'Have a free no obligation chat with up to 3 advisers who can give you bespoke quotes',
    },
];
